import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=88ee2dfe&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"
import style0 from "./Schedules.vue?vue&type=style&index=0&id=88ee2dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ee2dfe",
  null
  
)

export default component.exports